export default __webpack_public_path__ + "static/media/Choral-Dam.6316b5c7.jpg";